import React from 'react';
import MDSpinner from 'react-md-spinner';

export default class Loader extends React.PureComponent {

  static defaultProps = {
    className: 'loader',
  };

  render() {
    return (
      <div { ...this.props }>
        <MDSpinner singleColor="#cacbcc" size="50" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Loader.jsx